import React from 'react';
import PropTypes from 'prop-types';
import { v4 } from 'uuid';
import './MessageLog.css';

const copyLogToClipboard = (contactEvents, index) => {
  if (index === -1) {
    let copyMessage = [];
    const messageLogArray = []
    let messageLog = '';
    console.log('ci', contactEvents, index)
    contactEvents
      .reverse()
      .map(e => (
        messageLogArray.splice(0, messageLogArray.length),
        messageLogArray.push(e.timestamp.toLocaleTimeString(), e.message),
        messageLog = messageLogArray.join('  '),
        copyMessage.push(messageLog)
      ))
    let messageLogToCopy = copyMessage.join('\n')
    navigator.clipboard.writeText(messageLogToCopy)
  } else {
    let messageLogToCopy = [];
    const messageLogArray = []
    let messageLog = '';
    contactEvents
      .reverse()
      .map((e, i) => (

        (index === i ? (
          messageLogArray.push(e.timestamp.toLocaleTimeString(), e.message),
          messageLog = messageLogArray.join('  '),
          messageLogToCopy.push(messageLog),
          messageLogArray.splice(0, messageLogArray.length)) : '')
      ))

    navigator.clipboard.writeText(messageLogToCopy)
  }

}

const MessageLog = ({ contactEvents }) => (


  contactEvents.length > 0 ? (


    <ul className="message-log-list">
      <div className="center">
        <button  type="button" className="copyall-button" onClick = {() => copyLogToClipboard(contactEvents.reverse(), -1) } >
          Copy All
          <img className = "img" src="https://img.icons8.com/material/20/000000/copy--v1.png" alt=""/>
        </button>
      </div>
      <div >
        {contactEvents
          .reverse()
          .map((e, index) => (
            <li className="message-log-item" key={v4() } >
              <span  className="message-log-timestamp">{e.timestamp.toLocaleTimeString() }</span>
              <span>{e.message}</span>
              <div className="right">
                <button type="button" className="copy-button" onClick = {() => copyLogToClipboard(contactEvents.reverse(), index) }>
                  <img src="https://img.icons8.com/material/15/000000/copy--v1.png" alt=""/>
                </button>
              </div>
            </li>
          )) }
      </div>
    </ul>
  ) : (
      <div className="no-messages">
        <em>No messages</em>
      </div>
    ));

MessageLog.propTypes = {
  contactEvents: PropTypes.arrayOf(
    PropTypes.shape({
      message: PropTypes.string,
      timestamp: PropTypes.instanceOf(Date),
    }),
  ).isRequired,
};


export default MessageLog;
